export default __webpack_public_path__ + "static/3 - Átalakítás-bővítés-34f105caede761ce3cddf8cb5fb0a017.jpg";